import {normalizePlanning,invalidatePlanOutputs} from './planning.js';
export const PLAN_HISTORY_BYTES=4*1024*1024;
export const PLAN_HISTORY_LIMIT=200;
export function normalizePlanningHistory(value){
 return (Array.isArray(value)?value:[]).filter(row=>row&&typeof row==='object'&&Number.isSafeInteger(row.revision)&&row.revision>0).map(row=>({revision:row.revision,actor:String(row.actor||'').slice(0,100),at:String(row.at||'').slice(0,50),reason:String(row.reason||'').slice(0,100),plan:normalizePlanning(row.plan)}));
}
export function archivePlanning(c,{actor,at,reason}){
 if(!c.planning.revision)return;
 if(c.planningHistory.some(row=>row.revision===c.planning.revision))throw new Error('Duplicate planning history revision.');
 const entry={revision:c.planning.revision,actor,at,reason,plan:structuredClone(c.planning)};
 const next=[...c.planningHistory,entry];
 if(next.length>PLAN_HISTORY_LIMIT||new TextEncoder().encode(JSON.stringify(next)).length>PLAN_HISTORY_BYTES)throw Object.assign(new Error('Plan history storage limit reached. Export/archive this campaign before continuing in a new campaign. Existing history has not been removed.'),{status:409});
 c.planningHistory=next;
}
export function restorePlanning(c,op,{actor}){
 if(actor==='agent')throw new Error('A human must confirm restoring a historical plan.');
 if(op.revision!==c.planning.revision)throw Object.assign(new Error('Creative plan changed. Reload its current revision.'),{status:409});
 const entry=c.planningHistory.find(row=>row.revision===op.value?.restoreRevision);
 if(!entry)throw new Error('Historical plan revision is unavailable.');
 const before=c.planning,p=normalizePlanning(entry.plan),all=[before,...c.planningHistory.map(row=>row.plan)];
 p.revision=before.revision+1;
 p.briefRevision=before.briefRevision;
 p.strategy.revision=Math.max(...all.map(plan=>plan.strategy.revision))+1;
 p.strategy.briefRevision=entry.plan.strategy.briefRevision;
 p.concepts=p.concepts.map(concept=>({...concept,revision:Math.max(concept.revision,...all.flatMap(plan=>plan.concepts.filter(c=>c.id===concept.id).map(c=>c.revision)))+1,strategyRevision:0}));
 p.selection=null;
 if(p.storyboard)p.storyboard={...p.storyboard,revision:Math.max(...all.map(plan=>plan.storyboard?.revision||0))+1,conceptRevision:0};
 c.planning=p;
 invalidatePlanOutputs(c);
}
